import React, {
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import {setModalRoboyuLevelUpHandler} from 'utils'
import {ModalRoboyuLevelUpContext} from './ModalRoboyuLevelUpContext'
import ModalRoboyuLevelUpItem from './ModalRoboyuLevelUpItem'

interface ModalRoboyuLevelUpProviderProps {
  children: ReactNode
}
export default function ModalRoboyuLevelUpProvider({
  children,
}: ModalRoboyuLevelUpProviderProps) {
  const [openModal, setOpenModal] = useState<boolean>(false)

  const handleShowModal = useCallback(() => {
    setOpenModal(true)
  }, [])

  const handleHideModal = useCallback(() => {
    setOpenModal(false)
  }, [])

  const handleRenderModal = useMemo(() => {
    if (!openModal) {
      return
    }

    return <ModalRoboyuLevelUpItem toggleModal={handleHideModal} />
  }, [handleHideModal, openModal])

  const handler = useMemo(
    () => ({
      showModal: handleShowModal,
    }),
    [handleShowModal],
  )

  useEffect(() => {
    setModalRoboyuLevelUpHandler(handler)
  }, [handler])

  return (
    <ModalRoboyuLevelUpContext.Provider value={handler}>
      {handleRenderModal}
      {children}
    </ModalRoboyuLevelUpContext.Provider>
  )
}
